var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5612_17248)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5612_17248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.3529,
    cy: 42.3529,
    r: 42.3529,
    fill: "#C3C5C6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5612_17248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3333 36.9167C36.3333 35.4138 36.9304 33.9724 37.9931 32.9097C39.0558 31.847 40.4971 31.25 42 31.25C43.5029 31.25 44.9442 31.847 46.0069 32.9097C47.0696 33.9724 47.6667 35.4138 47.6667 36.9167C47.6667 38.4196 47.0696 39.8609 46.0069 40.9236C44.9442 41.9863 43.5029 42.5833 42 42.5833C40.4971 42.5833 39.0558 41.9863 37.9931 40.9236C36.9304 39.8609 36.3333 38.4196 36.3333 36.9167ZM36.3333 45.4167C34.4547 45.4167 32.653 46.1629 31.3247 47.4913C29.9963 48.8197 29.25 50.6214 29.25 52.5C29.25 53.6272 29.6978 54.7082 30.4948 55.5052C31.2918 56.3022 32.3728 56.75 33.5 56.75H50.5C51.6272 56.75 52.7082 56.3022 53.5052 55.5052C54.3022 54.7082 54.75 53.6272 54.75 52.5C54.75 50.6214 54.0037 48.8197 52.6753 47.4913C51.347 46.1629 49.5453 45.4167 47.6667 45.4167H36.3333Z",
    fill: "#676E76",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.3307 15.3333H58.9974C58.261 15.3333 57.6641 15.9303 57.6641 16.6667V24C57.6641 24.7364 58.261 25.3333 58.9974 25.3333H66.3307C67.0671 25.3333 67.6641 24.7364 67.6641 24V20.6667M66.7213 14.3905C67.242 13.8698 68.0862 13.8698 68.6069 14.3905C69.1276 14.9112 69.1276 15.7554 68.6069 16.2761L62.883 22H60.9974L60.9974 20.1144L66.7213 14.3905Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5612_17248",
    x: -4.70588,
    y: -2.35294,
    width: 94.1149,
    height: 94.1168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.35294
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35294
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0705882 0 0 0 0 0.0784314 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5612_17248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5612_17248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5612_17248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.7059,
    height: 84.7059,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5612_17248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(25 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4b881afe8379d65526486a54af9f868d.svg";
export { ForwardRef as ReactComponent };